import { render, staticRenderFns } from "./DSBrandingIcon.vue?vue&type=template&id=5444fe5c&scoped=true&"
import script from "./DSBrandingIcon.vue?vue&type=script&lang=js&"
export * from "./DSBrandingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5444fe5c",
  null
  
)

export default component.exports